import React from "react";
import { useDispatch } from "react-redux";
import { reduxForm, InjectedFormProps } from "redux-form";
import { useNavigate } from "react-router";

import { SubmitBtn } from "capitalrx-components";

import { uploadManualClaimBatchActions } from "@/App/actions/";
import ExcelFileUpload from "@/App/components/ExcelFileUpload";
import ManualClaimLayout from "@/App/layouts/ManualClaim";
import { TransmissionTypes } from "@/types";
import ResultTable from "./ResultTable";

const formName = "ManualClaimBatchUploadForm";

const ManualClaimBatchUpload: React.FC<InjectedFormProps> = (props: InjectedFormProps) => {
  const { handleSubmit, pristine, submitting } = props;
  const dispatch = useDispatch();
  const { uploadManualClaimBatch } = uploadManualClaimBatchActions;
  const navigate = useNavigate();

  const handleFormSubmit = (data: TransmissionTypes.ManualClaimBatchUploadFile): void => {
    dispatch(uploadManualClaimBatch(data, formName, navigate));
  };

  return (
    <ManualClaimLayout selected="rightToggle">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <ExcelFileUpload formName={formName} pristine={pristine} />
        <div className="row caprx-h-center-text">
          <SubmitBtn fullWidth={false} disabled={pristine} type="submit" submitting={submitting}>
            Manual Adjudication
          </SubmitBtn>
        </div>
      </form>

      <ResultTable />
    </ManualClaimLayout>
  );
};

export default reduxForm({ form: formName })(ManualClaimBatchUpload);
